import React, { useContext } from 'react';
import { getSharedComponent, MFContext } from '@4r/mf-host';
import { useConfig } from '@4r/module-common-mf-app';
import { UserModel } from '../../api/api';
import { UserContext } from '../../contexts/UserContext';

const OrdersPage = () => {
	const config = useConfig();
	const { WorkOrderMicrofrontend } = useContext(MFContext);

	const user = useContext(UserContext);

	const OrdersListPage = getSharedComponent('OrdersListPage') as React.FC<{
		googleApiKey: string;
		orderDetailsUrl: string;
		currentUser: UserModel | null;
		onlyMobileView?: boolean;
	}>;

	if (!WorkOrderMicrofrontend) {
		return null;
	}

	if (!OrdersListPage) {
		return null;
	}

	return <OrdersListPage orderDetailsUrl="/orders" googleApiKey={config.GOOGLE_MAP_KEY} currentUser={user.current} onlyMobileView />;
};

export default OrdersPage;
